import React, { useRef, useState, useEffect } from "react";
import "./dashboard.css";
import Remoteview from "../../Modules/Remote/Remoteview";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import close1 from "../../Assets/svg/close1.svg";
import dreports from "../../Assets/svg/dreports.svg";
import book from "../../Assets/svg/book.svg";
import carrow from "../../Assets/svg/carrow.svg";
import warrow from "../../Assets/svg/warrow.svg";
import teams from "../../Assets/svg/teams.svg";
import capcut from "../../Assets/svg/capcut.svg";
import projects from "../../Assets/svg/projects.svg";
import components from "../../Assets/svg/components.svg";
import colon from "../../Assets/svg/colon.svg";
import modules from "../../Assets/svg/modules.svg";
import clients from "../../Assets/svg/clients.svg";
import cancel from "../../Assets/svg/cancel.svg";
import { apiCall, apiCallGeneric } from "../../services/api-service.js";
//RemoteModal
import { Modal, Box } from "@mui/material";
import pfps from "../../Assets/svg/pfps.svg";
//over
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import UserImg from "../../Assets/png/user-icon.png";
import ProgressBar from "react-bootstrap/ProgressBar";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { ReactComponent as CalendarClose } from "../../Assets/svg/close1.svg";
import { ReactComponent as SearchBox } from "../../Assets/svg/chat-bot/Search.svg";

import { useGlobal } from "../../GlobalContext.js";
import { useUI } from "../../UIContext";
import ReactApexChart from "react-apexcharts";
import { Bar } from "react-chartjs-2";
// import { FiSearch } from "react-icons/fi"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import SegmentedBar from "../../common/common_progress.js";
import CustomChartCard from "../../common/custom_chart.js";
import StackedBar from "../../common/common_stack.js";
import TechSupportCard from "../../common/common_suport_card.js";
import {
  getApprovalApi,
  getescaltionApi,
  getLocationReportApi,
  getProjectReportApi,
  getRegionReportApi,
  getTeamReportApi,
  getUnallocatedApi,
} from "./dashboard-api.js";
import { useNavigate } from "react-router-dom";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const DashboardView = () => {
  const chartRef = useRef(null);
  const chartExpeRef = useRef(null);
  const chartMonthProRef = useRef(null);
  const chartProStatusRef = useRef(null);
  const navigate = useNavigate();
  const handleBarClick = (event) => {
    const chart = chartRef.current;

    if (!chart) return;

    // Get the clicked bar
    const elements = chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    );
    const endDate = createdDateRange?.[0]?.endDate;
    const endYear = endDate ? new Date(endDate).getFullYear() : null;

    console.log("End Year:", endYear);

    if (elements.length > 0) {
      const { index, datasetIndex } = elements[0];

      // Get label or data value if needed
      const label = createdDateBarChartData.labels[index];
      const value = createdDateBarChartData.datasets[datasetIndex].data[index];
      const year = createdDateList[index]["year"];

      console.log("Clicked bar:", label, value, year);
      const dateObj = new Date(label + " " + year);
      // Navigate to your list page (optionally pass state/query params)
      // navigate(`/list-page?date=${label}`);
      navigate("/ticket", {
        state: {
          filter_create: {
            start_date: dateObj,
            end_date: dateObj,
          },
          listing_type: createdDateType,
        },
      });
    }
  };
  const hasAnyPermission = (permissionsArray) => {
    // permissionsArray = [["Team", "menu_permission"], ["Project", "menu_permission"], ...]
    return permissionsArray.some(
      ([menuName, permission]) =>
        rolePermissionList.findIndex(
          (el) =>
            el.name === menuName &&
            el.menu_permission === true &&
            el[permission] === true
        ) > -1
    );
  };
  const handleBarExpectClick = (event) => {
    const chart = chartExpeRef.current;

    if (!chart) return;

    // Get the clicked bar
    const elements = chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    );
    if (elements.length > 0) {
      const { index, datasetIndex } = elements[0];

      // Get label or data value if needed
      const label = expectedDateBarChartData.labels[index];
      const value = expectedDateBarChartData.datasets[datasetIndex].data[index];
      const year = expectedDateList[index]["year"];

      console.log("Clicked bar:", label, value, year);
      const dateObj = new Date(label + " " + year);
      // Navigate to your list page (optionally pass state/query params)
      // navigate(`/list-page?date=${label}`);
      navigate("/ticket", {
        state: {
          filter_expt: {
            start_date: dateObj,
            end_date: dateObj,
          },
          listing_type: expectedDateType,
        },
      });
    }
  };
  const handleBarMonthlyClick = (event) => {
    const chart = chartMonthProRef.current;

    if (!chart) return;

    // Get the clicked bar
    const elements = chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    );

    if (elements.length > 0) {
      const { index, datasetIndex } = elements[0];
      let projectData = monthlyProjectList[index];
      console.log("barChartData.labels", monthlyProjectList[index]);
      // Get label or data value if needed
      const label = barChartData.labels[index];
      const value = barChartData.datasets[datasetIndex].data[index];
      console.log("label", label);
      navigate("/ticket", {
        state: {
          filter_create: {
            start_date: fromDate,
            end_date: toDate,
            project: { value: projectData.id, label: projectData.project },
          },

          listing_type: monthlyProjectType,
        },
      });
    }
  };
  const handleBarProjectStatClick = (event) => {
    const chart = chartProStatusRef.current;

    if (!chart) return;

    // Get the clicked bar
    const elements = chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    );

    if (elements.length > 0) {
      const { index, datasetIndex } = elements[0];
      let projectData = monProStatusReport[index];
      console.log("barChartData.labels", monProStatusReport[index]);
      // Get label or data value if needed
      const label = dataStack.labels[index];
      const value = dataStack.datasets[datasetIndex].data[index];
      console.log("label", label);
      navigate("/ticket", {
        state: {
          filter_create: {
            start_date: fromDate,
            end_date: toDate,
            project: { value: projectData.C, label: projectData.name },
          },

          listing_type: monthlyProjectStatusType,
        },
      });
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const { rolePermissionList, userType } = useGlobal();
  const { isCollapsed } = useUI();
  //RemoteModal
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const options = {
    responsive: true,
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length
        ? "pointer"
        : "default";
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        padding: 12,
        gap: 12,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            let value = context.parsed.y || 0;
            return `${label}:   ${value.toLocaleString()}\t`;
          },
        },
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        border: {
          display: false,
        },
      },
      y: {
        stacked: true,
        grid: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          borderDash: [5, 5], // dotted/dashed lines
          color: "rgba(0,0,0,0.1)", // line color
          lineWidth: 1,
        },
        border: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  // const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"];

  const [dataStack, setDataStack] = useState({});

  const hrmsApiUrl = process.env.REACT_APP_HRMS_API_URL;
  const [atWork, setAtWork] = useState([]);
  const [atBreak, setAtBreak] = useState([]);
  const [notWork, setNotWork] = useState([]);
  const [locationReport, setLocationReport] = useState([]);
  const [regionReport, setRegionReport] = useState([]);
  const [teamNewReport, setTeamNewReport] = useState([]);
  const [monProStatusReport, setMonProStatusReport] = useState([]);

  const totalList = async () => {
    const response = await apiCallGeneric("get", `${hrmsApiUrl}remote_work`);
    if (response?.status === 200 && response.data?.success === true) {
      setAtWork(response.data.data?.work ?? []);
      setAtBreak(response.data.data?.break ?? []);
      setNotWork(response.data.data?.away ?? []);
    }
  };

  useEffect(() => {
    totalList();
  }, []);
  useEffect(() => {
    getMonthlyProjectReport();
  }, [searchTerm]);
  //over

  const [showModal1, setShowModal1] = useState(false);
  const [advancedReportType, setAdvancedReportType] = useState("Team");
  const apiUrl = process.env.REACT_APP_API_URL;
  const dashboardGet = async (endpoint, params = {}) => {
    const response = await apiCall("get", endpoint, null, { params });
    return response?.data;
  };

  const dashboardPost = async (endpoint, payload = {}) => {
    const response = await apiCall("post", endpoint, payload);
    return response?.data;
  };

  const [ticketOverview, setTicketOverview] = useState({});
  const [inprogressTicketList, setInprogressTicketList] = useState([]);
  const [teamTotalTicket, setTeamTotalTicket] = useState(0);
  const [teamReport, setTeamReport] = useState({});
  const [teamChart, setTeamChart] = React.useState({
    series: [100, 100, 100, 100, 100],
    options: {
      chart: {
        height: 200,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "40%", // Reduce this to make bars thicker
          },
          track: {
            margin: 5, // Adjust the gap between bars
          },
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "16px",
              formatter: function (value) {
                return `${Number(value) || 0}`;
              },
            },
            total: {
              show: true,
              label: "Total",
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (value) {
            return `${Number(value) || 0}`;
          },
        },
      },
      grid: {
        padding: {
          top: -20,
          bottom: -20,
          left: -20,
          right: -20, // Removes outer padding
        },
      },
      colors: ["#6929E2", "#A677FF", "#CCACE6", "#CBAFFF", "#E4D6FF"],
      labels: ["Open", "In Progress", "Hold", "Closed", "Completed"],
    },
  });
  const [masterOverview, setMasterOverview] = useState({});
  const [recentlyUpdatedTicket, setRecentlyUpdatedTicket] = useState([]);
  const [recentlyAssignedTicket, setRecentlyAssignedTicket] = useState([]);
  const [escalationTicket, setEscalationTicket] = useState([]);
  const [approvalTicket, setApprovalTicket] = useState([]);
  const [unallocatedTicket, setUnallocatedTicket] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [monthlyProjectList, setMonthlyProjectList] = useState([]);
  const [monthlyProjectCountList, setMonthlyProjectCountList] = useState([]);
  const [createdDateCount, setCreatedDateCount] = useState(0);
  const [createdDateList, setCreatedDateList] = useState([]);
  const [createdDateType, setCreatedDateType] = useState("");
  const [expectedDateType, setExpectedDateType] = useState("");
  const [monthlyProjectType, setMonthlyProjectType] = useState("");
  const [vendorType, setVendorType] = useState("");
  const [regionType, setRegionType] = useState("");
  const [locationType, setLocationType] = useState("");
  const [teamType, setTeamType] = useState("");
  const [monthlyProjectStatusType, setMonthlyProjectStatusType] = useState("");
  const [createdDateCountList, setCreatedDateCountList] = useState([]);
  const [expectedDateCount, setExpectedDateCount] = useState(0);
  const [expectedDateList, setExpectedDateList] = useState([]);
  const [expectedDateCountList, setExpectedDateCountList] = useState([]);

  const barChartData = {
    labels: monthlyProjectList.map((item) => item.project),

    datasets: [
      {
        label: "",
        data: monthlyProjectList.map((item) => item.count),
        width: "100px",
        backgroundColor: "#6929E2",
        // backgroundColor: "#A677FF",
        // hoverBackgroundColor: "#6929E2",
        borderColor: "#CBAFFF",
        // borderColor: "#A677FF",
        borderWidth: 1,
        barThickness: 30,
        borderSkipped: false,
        borderRadius: 8,
        barPercentage: 0.4,
        categoryPercentage: 0.3,
        minBarLength: 5,
      },
    ],
  };

  const barChartOptions = {
    responsive: true,
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length
        ? "pointer"
        : "default";
    },
    maintainAspectRatio: false,
    layout: { padding: { top: 30 } },
    plugins: {
      legend: {
        display: false,
        position: "top",
      },

      title: {
        display: false,
        text: "Monthly Project Report",
      },
      tooltip: { enabled: false },
      datalabels: {
        display: true,
        color: "#6929E2",
        anchor: "end", // attach to the end of the bar
        align: "top", // move label ABOVE the bar
        offset: 4, // distance above bar top
        clip: false, // ensure labels aren’t cut off
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // show the bar’s count
      },
      // tooltip: {
      //   enabled: true,
      //   callbacks: {
      //     // Disable tooltip for the second dataset
      //     label: function (tooltipItem) {
      //       // Check if the dataset index is 1 (second dataset)
      //       if (tooltipItem.datasetIndex === 1) {
      //         return null; // Return null to hide the tooltip for the second dataset
      //       }
      //       return tooltipItem.raw; // Show the tooltip for other datasets
      //     },
      //   },
      // },
    },
    scales: {
      x: {
        stacked: true,

        grid: {
          display: false, // Hides gridlines for X-axis
        },
        border: { display: false },
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 14 ? label.substring(0, 12) + "..." : label;
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false, // Hides gridlines for Y-axis
        },
        ticks: {
          display: false, // Hides Y-axis labels (optional)
        },
        border: { display: false },
      },
    },
  };
  const [createdDateRange, setCreatedDateRange] = useState([
    {
      startDate: new Date().setDate(new Date().getDate() - 30),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [selectedCDRange, setSelectedCDRange] = useState([
    {
      startDate: new Date().setDate(new Date().getDate() - 30),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [showCDRangePicker, setShowCDRangePicker] = useState(false);

  const createdDateBarChartData = {
    labels: createdDateList.map((item) => item.period),
    datasets: [
      {
        label: "",
        data: createdDateCountList,
        width: "100px",
        // backgroundColor: "#F1E7FF",
        backgroundColor: "#6929E2",
        // hoverBackgroundColor: "#6929E2",
        borderColor: "#F1E7FF",
        borderWidth: 1,
        barThickness: 20,
        borderSkipped: false,
        borderRadius: 8,
        barPercentage: 0.3, // Increases bar width (0.1 to 1)
        categoryPercentage: 0.4, // Reduces category spacing (0.1 to 1)
      },
    ],
  };
  // const createdDateBarChartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   layout: {
  //     padding: 0,
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     tooltip: {
  //       enabled: false, // disable hover tooltip
  //     },
  //     datalabels: {
  //       display: true, // always visible
  //       color: "#6929E2",
  //       anchor: "end",
  //       align: "start",
  //       font: {
  //         size: 12,
  //         weight: "bold",
  //       },
  //       formatter: (value) => value, // show the bar value
  //     },
  //   },
  //   scales: {
  //     x: {
  //       grid: { display: false },
  //       border: { display: false },
  //       ticks: {
  //         callback: function (value) {
  //           const label = this.getLabelForValue(value);
  //           return label.length > 14 ? label.substring(0, 12) + "..." : label;
  //         },
  //       },
  //     },
  //     y: {
  //       beginAtZero: true,
  //       grid: { display: false },
  //       ticks: { display: false },
  //       border: { display: false },
  //     },
  //   },
  // };
  const createdDateBarChartOptions = {
    responsive: true,
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length
        ? "pointer"
        : "default";
    },
    maintainAspectRatio: false,
    layout: { padding: { top: 30 } }, // small top space for labels
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: {
        display: true,
        color: "#6929E2",
        anchor: "end", // attach to the end of the bar
        align: "top", // move label ABOVE the bar
        offset: 4, // distance above bar top
        clip: false, // ensure labels aren’t cut off
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // show the bar’s count
      },
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 14 ? label.substring(0, 12) + "..." : label;
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: { display: false },
        ticks: { display: false },
        border: { display: false },
      },
    },
  };

  // const createdDateBarChartOptions = {
  // responsive: true,
  // maintainAspectRatio: false,
  // layout: {
  //   padding: 0,
  // },
  // plugins: {
  //   legend: {
  //     display: false,
  //   },
  //   tooltip: {
  //     enabled: false, // hide hover tooltip since we’ll show values above
  //   },
  //   datalabels: {
  //     display: true,
  //     color: "#6929E2",        // text color
  //     anchor: "end",           // position label relative to bar
  //     align: "start",          // position above bar
  //     offset: -4,              // space between bar top and label
  //     font: {
  //       weight: "bold",
  //       size: 12,
  //     },
  //     formatter: (value) => value, // show the actual count value
  //   },
  // },
  // scales: {
  //   x: {
  //     grid: { display: false },
  //     border: { display: false },
  //     ticks: {
  //       callback: function (value) {
  //         const label = this.getLabelForValue(value);
  //         return label.length > 14 ? label.substring(0, 12) + "..." : label;
  //       },
  //     },
  //   },
  //   y: {
  //     beginAtZero: true,
  //     grid: { display: false },
  //     ticks: { display: false },
  //     border: { display: false },
  //   },
  // },
  // };
  const [showEDRangePicker, setShowEDRangePicker] = useState(false);
  const [expectedDateRange, setExpectedDateRange] = useState([
    {
      startDate: new Date().setDate(new Date().getDate() - 30), // Clear start date
      endDate: new Date(), // Clear end date
      key: "selection",
    },
  ]);
  const [selectedEDRange, setSelectedEDRange] = useState([
    {
      startDate: new Date().setDate(new Date().getDate() - 30), // Clear start date
      endDate: new Date(), // Clear end date
      key: "selection",
    },
  ]);
  const expectedDateBarChartData = {
    labels: expectedDateList.map((item) => item.period),
    datasets: [
      {
        label: "",
        data: expectedDateCountList,
        width: "100px",
        // backgroundColor: "#F1E7FF",
        backgroundColor: "#6929E2",
        // hoverBackgroundColor: "#6929E2",
        borderColor: "#F1E7FF",
        borderWidth: 1,
        barThickness: 20,
        borderSkipped: false,
        borderRadius: 8,
        barPercentage: 0.3, // Increases bar width (0.1 to 1)
        categoryPercentage: 0.4, // Reduces category spacing (0.1 to 1)
      },
    ],
  };
  const expectedDateBarChartOptions = {
    responsive: true,
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length
        ? "pointer"
        : "default";
    },
    maintainAspectRatio: false,
    layout: {
      padding: { top: 30 }, // small top padding so labels aren't cut off
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Monthly Project Report",
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            // Disable tooltip for second dataset (if any)
            if (tooltipItem.datasetIndex === 1) {
              return null;
            }
            return tooltipItem.raw;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#6929E2",
        anchor: "end", // attaches to the end of the bar
        align: "top", // places label ABOVE the bar
        offset: 6, // spacing between label and bar top
        clip: false, // ensures label isn't cut off at chart top
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // show the bar’s count
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false, // hide gridlines on X-axis
        },
        border: { display: false },
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 14 ? label.substring(0, 12) + "..." : label;
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false, // hide gridlines on Y-axis
        },
        ticks: {
          display: false, // hide Y-axis labels
        },
        border: { display: false },
      },
    },
  };

  // const expectedDateBarChartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   layout: {
  //     padding: 0, // Removes extra padding
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //       position: "top",
  //     },
  //     title: {
  //       display: false,
  //       text: "Monthly Project Report",
  //     },
  //     tooltip: {
  //       enabled: true,
  //       callbacks: {
  //         // Disable tooltip for the second dataset
  //         label: function (tooltipItem) {
  //           // Check if the dataset index is 1 (second dataset)
  //           if (tooltipItem.datasetIndex === 1) {
  //             return null; // Return null to hide the tooltip for the second dataset
  //           }
  //           return tooltipItem.raw; // Show the tooltip for other datasets
  //         },
  //       },
  //     },
  //   },
  //     plugins: {
  //     legend: { display: false },
  //     tooltip: { enabled: false },
  //     datalabels: {
  //       display: true,
  //       color: "#6929E2",
  //       anchor: "end", // attach to the end of the bar
  //       align: "top", // move label ABOVE the bar
  //       offset: 4, // distance above bar top
  //       clip: false, // ensure labels aren’t cut off
  //       font: {
  //         size: 12,
  //         weight: "bold",
  //       },
  //       formatter: (value) => value, // show the bar’s count
  //     },
  //   },
  //   scales: {
  //     x: {
  //       stacked: true,

  //       grid: {
  //         display: false, // Hides gridlines for X-axis
  //       },
  //       border: { display: false },
  //       ticks: {
  //         callback: function (value) {
  //           const label = this.getLabelForValue(value);
  //           return label.length > 14 ? label.substring(0, 12) + "..." : label;
  //         },
  //       },
  //     },
  //     y: {
  //       stacked: true,
  //       beginAtZero: true,
  //       grid: {
  //         display: false, // Hides gridlines for Y-axis
  //       },
  //       ticks: {
  //         display: false, // Hides Y-axis labels (optional)
  //       },
  //       border: { display: false },
  //     },
  //   },
  // };
  useEffect(() => {
    setFromDate(moment().startOf("month").format("YYYY-MM-DD"));

    setToDate(moment(new Date()).format("YYYY-MM-DD"));
    getTicketOverview();
    getInprogressList();

    /* getMonthlyReport(); */
    getMasterOverview();
    getRecentlyUpdatedTicket();

    getCustomerList();
    getVendorList();
  }, []);
  useEffect(() => {
    if (fromDate != null && toDate != null) {
      console.log("From Date:", fromDate);
      console.log("To Date:", toDate);
      getTeamReport();
      setMonthlyProjectCountList(
        monthlyProjectList.map((item) => Number(item.count)) ?? []
      );
      getMonthlyReport();
      getCreatedDateReport();
      getExpectedDateReport();
      getEscalatedTicket();
      getApprovalTicket();
      getUnallocatedTicket();
      getLocationReport();
      getRegionReport();
      getTeamNewReport();
      getMonthlyProjectReport();
      getRecentlyAssignedTicket();
      getCustomerList();
      getVendorList();
    }
  }, [fromDate, toDate]);
  useEffect(() => {
    getCreatedDateReport();
  }, [selectedCDRange]);
  useEffect(() => {
    getExpectedDateReport();
  }, [selectedEDRange]);
  const getTicketOverview = async () => {
    const data = await dashboardGet("dashboard/ticket_overview");
    if (data?.success === true) {
      setTicketOverview(data.data ?? {});
    }
  };
  const getInprogressList = async () => {
    const data = await dashboardGet("dashboard/get_inprogress_tickets");
    if (data?.success === true) {
      setInprogressTicketList(data.tickets ?? []);
    }
  };

  const getTeamReport = async () => {
    const data = await dashboardPost("dashboard/team_report", {
      from_date: fromDate,
      to_date: toDate,
    });
    if (data?.success === true) {
      setTeamTotalTicket(data.data?.team ?? 0);
      setTeamReport(data.data ?? {});
      setTeamType(data.type ?? "");
      setTeamChart((prevChart) => ({
        ...prevChart,
        series: [
          data.data?.open ?? 0,
          data.data?.inprogress ?? 0,
          data.data?.hold ?? 0,
          data.data?.closed ?? 0,
          data.data?.completed ?? 0,
        ],
      }));
    }
  };
  const getYourReport = async () => {
    const data = await dashboardPost("dashboard/your_report", {
      from_date: fromDate,
      to_date: toDate,
    });
    if (data?.success === true) {
      setTeamTotalTicket(data.data?.team ?? 0);
      setTeamReport(data.data ?? {});
      setTeamChart((prevChart) => ({
        ...prevChart,
        series: [
          data.data?.open ?? 0,
          data.data?.inprogress ?? 0,
          data.data?.hold ?? 0,
          data.data?.closed ?? 0,
          data.data?.completed ?? 0,
        ],
      }));
    }
  };
  const getCreatedDateReport = async () => {
    const data = await dashboardPost("dashboard/created_date_report", {
      from_date:
        selectedCDRange[0].startDate === null
          ? ""
          : commonFormatDate(selectedCDRange[0].startDate, "YYYY-MM-DD"),
      to_date:
        selectedCDRange[0].endDate === null
          ? ""
          : commonFormatDate(selectedCDRange[0].endDate, "YYYY-MM-DD"),
    });
    if (data?.success === true) {
      setCreatedDateCount(data.total ?? "0");
      setCreatedDateList(data.data ?? []);
      setCreatedDateType(data.type ?? "");
      setCreatedDateCountList(data.data?.map((item) => Number(item.count)) ?? []);
    }
  };
  const getExpectedDateReport = async () => {
    const data = await dashboardPost("dashboard/expected_date_report", {
      from_date:
        selectedEDRange[0].startDate === null
          ? ""
          : commonFormatDate(selectedEDRange[0].startDate, "YYYY-MM-DD"),
      to_date:
        selectedEDRange[0].endDate === null
          ? ""
          : commonFormatDate(selectedEDRange[0].endDate, "YYYY-MM-DD"),
    });
    if (data?.success === true) {
      setExpectedDateCount(data.total ?? "0");
      setExpectedDateList(data.data ?? []);
      setExpectedDateType(data.type ?? "");
      setExpectedDateCountList(data.data?.map((item) => Number(item.count)) ?? []);
    }
  };
  const getMonthlyReport = async () => {
    const data = await dashboardPost("dashboard/monthly_report", {
      from_date: fromDate,
      to_date: toDate,
    });
    if (data?.success === true) {
      setMonthlyProjectList(data.data ?? []);
      setMonthlyProjectType(data.type ?? "");
      setMonthlyProjectCountList(data.data?.map((item) => Number(item.count)) ?? []);
    }
  };
  const getMasterOverview = async () => {
    const data = await dashboardGet("dashboard/master_overview");
    if (data?.success === true) {
      setMasterOverview(data.data ?? {});
    }
  };
  const getRecentlyUpdatedTicket = async () => {
    const data = await dashboardGet("dashboard/updated_ticket");
    if (data?.success === true) {
      setRecentlyUpdatedTicket(data.tickets ?? []);
    }
  };
  const getEscalatedTicket = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getescaltionApi(bodyData);

      if (response?.success) {
        setEscalationTicket(response.tickets ?? []);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };
  const getApprovalTicket = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getApprovalApi(bodyData);

      if (response?.success) {
        setApprovalTicket(response.tickets ?? []);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };
  const getUnallocatedTicket = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getUnallocatedApi(bodyData);

      if (response?.success) {
        setUnallocatedTicket(response.tickets);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };
  const getLocationReport = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getLocationReportApi(bodyData);

      if (response?.success) {
        let locationList = response.data;
        setLocationType(response.type);
        const formatted = locationList.map((item) => ({
          id: item.id,
          title: item.name, // adjust to your API field
          overall: item.overall,
          legendData: {
            open: (item.open / item.overall) * 100 || 0,
            progress: (item.in_progress / item.overall) * 100 || 0,
            hold: (item.hold / item.overall) * 100 || 0,
            closed: (item.closed / item.overall) * 100 || 0,
            completed: (item.completed / item.overall) * 100 || 0,
          },
          legendValue: {
            open: item.open,
            progress: item.in_progress,
            hold: item.hold,
            closed: item.closed,
            completed: item.completed,
          },
        }));
        setLocationReport(formatted);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };
  const getRegionReport = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getRegionReportApi(bodyData);

      if (response?.success) {
        let regionList = response.data;
        setRegionType(response.type);
        const formatted = regionList.map((item) => ({
          id: item.id,
          title: item.name, // adjust to your API field
          overall: item.overall,
          legendData: {
            open: (item.open / item.overall) * 100 || 0,
            progress: (item.in_progress / item.overall) * 100 || 0,
            hold: (item.hold / item.overall) * 100 || 0,
            closed: (item.closed / item.overall) * 100 || 0,
            completed: (item.completed / item.overall) * 100 || 0,
          },
          legendValue: {
            open: item.open,
            progress: item.in_progress,
            hold: item.hold,
            closed: item.closed,
            completed: item.completed,
          },
        }));
        setRegionReport(formatted);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };
  const getTeamNewReport = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
      };
      const response = await getTeamReportApi(bodyData);

      if (response?.success) {
        let locationList = response.data;
        const formatted = locationList.map((item) => ({
          id: item.id,
          title: item.name,
          overall: item.overall,
          open: item.open,
          progress: item.in_progress,
          closed: item.closed,
          hold: item.hold,
          completed: item.completed,
          open_per: (item.open / item.overall) * 100 || 0,
          progress_per: (item.in_progress / item.overall) * 100 || 0,
          closed_per: (item.closed / item.overall) * 100 || 0,
          hold_per: (item.hold / item.overall) * 100 || 0,
          completed_per: (item.hold / item.overall) * 100 || 0,
        }));
        setTeamNewReport(formatted);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };

  const getMonthlyProjectReport = async () => {
    try {
      const bodyData = {
        from_date: fromDate,
        to_date: toDate,
        search: searchTerm,
      };
      const response = await getProjectReportApi(bodyData);

      if (response?.success) {
        let locationList = response.data;
        setMonProStatusReport(response.data);
        setMonthlyProjectStatusType(response.type);
        setDataStack({});

        const completedData = locationList.map((item) => item.completed);
        const closedData = locationList.map((item) => item.closed);
        const holdData = locationList.map((item) => item.hold);
        const progressData = locationList.map((item) => item.in_progress);
        const openData = locationList.map((item) => item.open);

        // define datasets in top-down order
        const datasetsOrder = [
          { key: "completed", data: completedData },
          { key: "closed", data: closedData },
          { key: "progress", data: progressData },
          { key: "hold", data: holdData },
          { key: "open", data: openData },
        ];

        const getBorderRadiusForIndex = (index, datasetKey) => {
          // find first dataset with non-zero value at this index
          const topDataset = datasetsOrder.find(({ data }) => data[index] > 0);

          if (topDataset && topDataset.key === datasetKey) {
            return { topLeft: 8, topRight: 8, bottomLeft: 0, bottomRight: 0 };
          }

          return 0;
        };
        console.log("closedData", closedData);
        console.log("holdData", holdData);
        console.log("progressData", progressData);
        console.log("openData", openData);

        if (locationList.length > 0) {
          setDataStack({
            labels: locationList.map((item) => item.name),
            datasets: [
              {
                label: "Open",
                data: openData,
                backgroundColor: "#6929E2",
                maxBarThickness: 20,
                borderRadius: openData.map((_, i) =>
                  getBorderRadiusForIndex(i, "open")
                ),
              },
              {
                label: "Progress",
                data: progressData,
                backgroundColor: "#A677FF",
                maxBarThickness: 20,
                borderRadius: progressData.map((_, i) =>
                  getBorderRadiusForIndex(i, "progress")
                ),
              },
              {
                label: "Hold",
                data: holdData,
                backgroundColor: "#CCACE6",
                maxBarThickness: 20,
                borderRadius: holdData.map((_, i) =>
                  getBorderRadiusForIndex(i, "hold")
                ),
              },
              {
                label: "Closed",
                data: closedData,
                backgroundColor: "#CBAFFF",
                maxBarThickness: 20,
                borderRadius: closedData.map((_, i) =>
                  getBorderRadiusForIndex(i, "closed")
                ),
              },
              {
                label: "Completed",
                data: completedData,
                backgroundColor: "#E4D6FF",
                maxBarThickness: 20,
                borderRadius: completedData.map((_, i) =>
                  getBorderRadiusForIndex(i, "completed")
                ),
              },
            ],
          });
        }
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        if (error.response.status === 400) {
          // handle specific 400 case here
        }
      } else {
        console.error("Network or unexpected error:", error.message);
      }
    }
  };

  const getRecentlyAssignedTicket = async () => {
    const data = await dashboardGet("dashboard/assigned_ticket");
    if (data?.success === true) {
      setRecentlyAssignedTicket(data.tickets ?? []);
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "Created":
        return "#BEA5EF";

      case "Open":
        return "#BEA5EF";

      case "In Progress":
        return "#FF9A6C";

      case "Hold":
        return "#FF9A6C";

      case "Closed":
        return "#5DCB8C";
      case "Completed":
        return "#5DCB8C";
      default:
        return "#BEA5EF";
    }
  };
  const alertCDPicRef = useRef(null);
  const alertEDPicRef = useRef(null);
  const handleClickOutside = (event) => {
    if (
      alertCDPicRef.current &&
      !alertCDPicRef.current.contains(event.target)
    ) {
      setShowCDRangePicker(false);
    }
    if (
      alertEDPicRef.current &&
      !alertEDPicRef.current.contains(event.target)
    ) {
      setShowEDRangePicker(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
          const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
   
          // Format the date
          return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(inputDate).format(formatString);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const [customerBillingTicketCount, setCustomerBillingTicketCount] =
    useState(0);
  const [customerList, setCustomerList] = useState([]);
  const getCustomerList = async () => {
    const data = await dashboardPost("dashboard/customer_ticket_count", {
      from_date: fromDate,
      to_date: toDate,
    });
    if (data?.success === true) {
      setCustomerBillingTicketCount(data.total ?? 0);
      setCustomerList(data.data ?? []);
    }
  };

  const [vendorBillingTicketCount, setVendorBillingTicketCount] = useState(0);
  const [vendorList, setVendorList] = useState([]);
  const getVendorList = async () => {
    const data = await dashboardPost("dashboard/vendor_ticket_count", {
      from_date: fromDate,
      to_date: toDate,
    });
    if (data?.success === true) {
      setVendorBillingTicketCount(data.total ?? 0);
      setVendorList(data.data ?? []);
      setVendorType(data.type ?? "");
    }
  };

  const calculateDays = (startDate, endDate) => {
    const days = moment(commonFormatDate(endDate, "YYYY-MM-DD")).diff(
      moment(commonFormatDate(startDate, "YYYY-MM-DD")),
      "days"
    );
    return days + 1 /*  === 0 ? 1 : Math.abs(days) */;
  };
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex " style={{ overflowX: "hidden" }}>
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <Col style={{ padding: "16px" }}>
              <div
                style={{
                  height: "100%",
                  marginBottom: "16px",
                  backgroundColor: "#F6F7F8",
                }}
              >
                <div
                  style={{
                    /* height:'72px', */ borderRadius: "16px",
                    padding: "16px",
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ gap: "12px" }}>
                    <div>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "20px",
                          lineHeight: "22px",
                          color: "#212129",
                        }}
                        onClick={handleOpen}
                      >
                        Dashboard
                      </span>

                      <div
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#8790A1",
                        }}
                      >
                        Your application’s overall analytics and overview of
                        your records details are displayed here
                      </div>
                    </div>
                  </div>
                  {/* <div style={{height:'40px',borderRadius:'100px',padding:'8px 16px 8px 16px',gap:'8px',backgroundColor:'#6929E2',display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={dreports} style={{width:'14px',height:'14px'}}/> 
                            <span style={{margin:'0',fontFamily:'Satoshi',fontWeight:'700',fontSize:'14px',lineHeight:'18.9px',color:'#FFFFFF'}}>Download Reports</span>
                        </div> */}
                </div>

                <Row className="mb-3">
                  <Col sm={12} lg={7} xl={6}>
                    <Row>
                      <Col sm={12} lg={8} xl={8} style={{ marginTop: "16px" }}>
                        <div
                          style={{
                            height: "294px",
                            borderRadius: "24px",
                            padding: "16px",
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                          <div style={{ marginBottom: "24px" }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "16px",
                                lineHeight: "22px",
                                color: "#212129",
                              }}
                            >
                              Tickets overview
                            </span>
                          </div>

                          <div
                            style={{
                              width: "197px",
                              height: "68px",
                              gap: "12px",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "143px",
                                height: "32px",
                                whiteSpace: "normal",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "12px",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "24px",
                                  lineHeight: "16px",
                                  color: "#212129",
                                  margin: "0",
                                  marginRight: "12px",
                                }}
                              >
                                {ticketOverview.total ?? "0"}
                              </span>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "16px",
                                  color: "#8790A1",
                                  margin: "0",
                                }}
                              >
                                Total Tickets Count
                              </span>
                            </div>

                            <div
                              style={{
                                borderRadius: "32px",
                                padding: "8px 13px 8px 13px",
                                gap: "10px",
                                backgroundColor: "#F9F5FF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "24px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0",
                                  ontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "11px",
                                  lineHeight: "22px",
                                  color: "#212129",
                                }}
                              >
                                Date of your joining:{" "}
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "11px",
                                    lineHeight: "22px",
                                    color: "#212129",
                                  }}
                                >
                                  {ticketOverview.doj ?? "---"}
                                </span>
                              </p>
                            </div>
                          </div>

                          <Row
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                            }}
                          >
                            <Col xs={4} sm={4} md={6} xl={6}>
                              <div
                                className="mx-1"
                                style={{
                                  height: "126px",
                                  borderRadius: "20px",
                                  padding: "16px 24px 16px 24px",
                                  gap: "8px",
                                  backgroundColor: "#F7F7F7",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_status: {
                                        label: "Open",
                                        value: "Open",
                                      },
                                      listing_type: ticketOverview.type ?? "",
                                    },
                                  });
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    margin: "0",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "0",
                                    }}
                                  >
                                    <img
                                      src={book}
                                      style={{
                                        width: "15.79px",
                                        height: "14.33px",
                                        margin: "0",
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "0",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "400",
                                        fontSize: "13px",
                                        lineHeight: "16px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      Open
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "0",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "18px",
                                        lineHeight: "26px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {ticketOverview.open ?? "0"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col xs={4} sm={4} md={6} xl={6}>
                              <div
                                className="mx-1"
                                style={{
                                  height: "126px",
                                  borderRadius: "20px",
                                  padding: "16px 24px 16px 24px",
                                  gap: "8px",
                                  backgroundColor: "#F7F7F7",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_status: {
                                        label: "Hold",
                                        value: "Hold",
                                      },
                                      listing_type: ticketOverview.type ?? "",
                                    },
                                  });
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={book}
                                      style={{
                                        width: "15.79px",
                                        height: "14.33px",
                                        margin: "0",
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "400",
                                        fontSize: "13px",
                                        lineHeight: "16px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      Hold
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "18px",
                                        lineHeight: "26px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {ticketOverview.hold ?? "0"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        lg={4}
                        xl={4}
                        style={{ margin: "0", padding: "0", marginTop: "16px" }}
                      >
                        <div
                          className="w-100 d-flex flex-column flex-sm-row flex-lg-column"
                          style={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginLeft: "8px",
                            marginRight: "16px",
                            gap: "16px",
                          }}
                        >
                          <div
                            className="w-100"
                            style={{
                              height: "87.33px",
                              borderRadius: "16px",
                              padding: "12px 16px 12px 0px",
                              backgroundColor: "#FFFFFF",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/ticket", {
                                state: {
                                  filter_status: {
                                    label: "In Progress",
                                    value: "In Progress",
                                  },
                                  listing_type: ticketOverview.type ?? "",
                                },
                              });
                            }}
                          >
                            <div
                              style={{
                                width: "4px",
                                height: "40px",
                                borderRadius: "27px 17px 27px 17px",
                                backgroundColor: "#A373FF",
                              }}
                            ></div>

                            <div style={{ height: "54px", width: "54px" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                }}
                              >
                                Inprogress
                              </p>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "18px",
                                  lineHeight: "24.3px",
                                  color: "#212129",
                                }}
                              >
                                {ticketOverview.inprogress ?? "0"}
                              </span>
                            </div>

                            <div
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                                border: "0.5px solid #E5E5E5",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "28px",
                              }}
                            >
                              <img
                                src={carrow}
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  margin: "0",
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="w-100"
                            style={{
                              height: "87.33px",
                              borderRadius: "16px",
                              padding: "12px 16px 12px 0px",
                              backgroundColor: "#FFFFFF",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/ticket", {
                                state: {
                                  filter_status: {
                                    label: "Closed",
                                    value: "Closed",
                                  },
                                  listing_type: ticketOverview.type ?? "",
                                },
                              });
                            }}
                          >
                            <div
                              style={{
                                width: "4px",
                                height: "40px",
                                borderRadius: "27px 17px 27px 17px",
                                backgroundColor: "#90A4FF",
                              }}
                            ></div>

                            <div style={{ height: "54px", width: "54px" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                }}
                              >
                                Closed
                              </p>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "18px",
                                  lineHeight: "24.3px",
                                  color: "#212129",
                                }}
                              >
                                {ticketOverview.closed ?? "0"}
                              </span>
                            </div>

                            <div
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                                border: "0.5px solid #E5E5E5",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "28px",
                              }}
                            >
                              <img
                                src={carrow}
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  margin: "0",
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="w-100"
                            style={{
                              height: "87.33px",
                              borderRadius: "16px",
                              padding: "12px 16px 12px 0px",
                              backgroundColor: "#FFFFFF",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate("/ticket", {
                                state: {
                                  filter_status: {
                                    label: "Completed",
                                    value: "Completed",
                                  },
                                  listing_type: ticketOverview.type ?? "",
                                },
                              });
                            }}
                          >
                            <div
                              style={{
                                width: "4px",
                                height: "40px",
                                borderRadius: "27px 17px 27px 17px",
                                backgroundColor: "#5DCB8C",
                              }}
                            ></div>

                            <div style={{ height: "54px", width: "54px" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                }}
                              >
                                Completed
                              </p>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "18px",
                                  lineHeight: "24.3px",
                                  color: "#212129",
                                }}
                              >
                                {ticketOverview.completed ?? "0"}
                              </span>
                            </div>

                            <div
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                                border: "0.5px solid #E5E5E5",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "28px",
                              }}
                            >
                              <img
                                src={carrow}
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  margin: "0",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  {
                    <Col sm={12} lg={5} xl={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          borderRadius: "24px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                          height: "294px",
                          overflowY: "scroll",
                          whiteSpace: "nowrap",
                          overflowX: "hidden",
                        }}
                      >
                        <div style={{ height: "12px", marginBottom: "24px" }}>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "22px",
                              color: "#212129",
                            }}
                          >
                            Inprogress Tickets: {inprogressTicketList.length}
                          </span>
                        </div>

                        {inprogressTicketList.map((item, index) => {
                          const [workingDuration, milliseconds] =
                            item.duration?.split(".") || ["00:00", ""];
                          return (
                            <div
                              style={{
                                borderRadius: "16px",
                                padding: "16px",
                                backgroundColor: "#F9F5FF",
                                marginBottom: "16px",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  height: "20px",
                                  borderLeft: "4px solid #6929E2",
                                  padding: "5px 40px 5px 12px",
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    color: "#212129",
                                    margin: "0",
                                  }}
                                >
                                  {item.title}
                                </span>
                              </div>

                              <div
                                style={{
                                  width: "129px",
                                  height: "9px",
                                  marginBottom: "8px",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "400",
                                    fontSize: "13px",
                                    lineHeight: "22px",
                                    color: "#212129",
                                  }}
                                >
                                  Estimation:{" "}
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "13px",
                                      lineHeight: "22px",
                                      color: "#6929B2",
                                    }}
                                  >
                                    {item.est ?? "00:00"}
                                  </span>{" "}
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "400",
                                      fontSize: "13px",
                                      lineHeight: "22px",
                                      color: "#212129",
                                    }}
                                  >
                                    hrs
                                  </span>
                                </p>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    height: "32px",
                                    marginTop: "16px",
                                    backgroundColor: "#FFFFFF",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                    padding: "7px 12px",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "0",
                                      paddingRight: "8px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        borderRadius: "3px",
                                        margin: "0",
                                        backgroundColor: "#6929E2",
                                        marginRight: "4.9px",
                                      }}
                                    ></div>
                                    <p
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "18.9px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      InProgress
                                    </p>
                                  </div>

                                  <p style={{ margin: "0" }}>|</p>

                                  <div
                                    style={{ margin: "0", paddingLeft: "8px" }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "14px",
                                        lineHeight: "18.9px",
                                        color: "#212129",
                                      }}
                                    >
                                      {workingDuration} hrs
                                    </span>
                                  </div>
                                </div>

                                <Link
                                  to={`/ticket/view/${item.id}`}
                                  state={{ id: item.id }}
                                  className="link23"
                                >
                                  <div
                                    style={{
                                      width: "117px",
                                      height: "32px",
                                      marginTop: "16px",
                                      borderRadius: "44px",
                                      padding: "7px 12px 7px 12px",
                                      backgroundColor: "#6929E2",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                        lineHeight: "17.55px",
                                        color: "#FFFFFF",
                                        margin: "0",
                                        marginRight: "4.9px",
                                      }}
                                    >
                                      View Details
                                    </span>
                                    <div
                                      style={{
                                        width: "13px",
                                        height: "8.12px",
                                        margin: "0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={warrow}
                                        style={{ margin: "0" }}
                                      />
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Col>
                  }
                </Row>
                <Row>
                  <Col sm={12} md={6} style={{ marginTop: "16px" }}>
                    <div
                      style={{
                        /* height: '250px', */ borderRadius: "16px",
                        padding: "16px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <div className="d-flex flex-column">
                              <div
                                style={{
                                  fontWeight: "700",
                                  fontSize: "16px",
                                  color: "#212129",
                                }}
                              >
                                Created date based count
                              </div>

                              <div
                                style={{
                                  fontWeight: "400",
                                  fontSize: "12.5px",
                                  color: "#546088",
                                }}
                              >
                                Tickets count of these{" "}
                                {calculateDays(
                                  selectedCDRange[0].startDate,
                                  selectedCDRange[0].endDate
                                )}{" "}
                                days
                              </div>
                            </div>

                            <div
                              className="d-flex"
                              style={{ marginLeft: "12px" }}
                            >
                              <img src={colon} alt="" />
                            </div>

                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "20px",
                                color: "#6929E2",
                              }}
                            >
                              {createdDateCount}
                            </div>
                          </div>

                          <div>
                            {selectedCDRange[0].startDate != null && (
                              <div
                                onClick={() =>
                                  setShowCDRangePicker(!showCDRangePicker)
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  background: "#ffffff",
                                  border: "1px solid #6929E2",
                                  borderRadius: "8px",
                                  padding: "2px 6px",
                                }}
                              >
                                <div
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#6929E2",
                                  }}
                                >
                                  {" "}
                                  {commonFormatDate(
                                    selectedCDRange[0].startDate,
                                    "DD MMM"
                                  )}{" "}
                                  -{" "}
                                  {commonFormatDate(
                                    selectedCDRange[0].endDate,
                                    "DD MMM YYYY"
                                  )}{" "}
                                </div>
                                <CalendarClose
                                  onClick={() => {
                                    setCreatedDateRange([
                                      {
                                        startDate: new Date(), // Clear start date
                                        endDate: new Date(), // Clear end date
                                        key: "selection",
                                      },
                                    ]);
                                    setSelectedCDRange([
                                      {
                                        startDate: new Date(), // Clear start date
                                        endDate: new Date(), // Clear end date
                                        key: "selection",
                                      },
                                    ]);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#6929E2",
                                    marginLeft: "2px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {showCDRangePicker && (
                          <div
                            ref={alertCDPicRef}
                            style={{
                              position: "absolute",
                              top: "60px",
                              zIndex: 100,
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            <DateRangePicker
                              key={"createdDateRange"}
                              ranges={createdDateRange}
                              onChange={(item) => {
                                setCreatedDateRange([item.selection]);
                                setSelectedCDRange([item.selection]);
                              }}
                              showSelectionPreview={true}
                              moveRangeOnFirstSelection={false}
                              months={1} // Show two months
                              direction="horizontal"
                            />
                          </div>
                        )}
                      </div>
                      <div style={{ width: "100%", overflowX: "scroll" }}>
                        <div
                          style={{
                            minWidth: createdDateList.length * 50,
                            height: "200px",
                          }}
                        >
                          {" "}
                          {/* Set minWidth for scrolling */}
                          <Bar
                            ref={chartRef}
                            data={createdDateBarChartData}
                            options={createdDateBarChartOptions}
                            plugins={[ChartDataLabels]}
                            onClick={handleBarClick}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6} style={{ marginTop: "16px" }}>
                    <div
                      style={{
                        /* height: '250px', */ borderRadius: "16px",
                        padding: "16px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <div className="d-flex flex-column">
                              <div
                                style={{
                                  fontWeight: "700",
                                  fontSize: "16px",
                                  color: "#212129",
                                }}
                              >
                                Expected date based count
                              </div>

                              <div
                                style={{
                                  fontWeight: "400",
                                  fontSize: "12.5px",
                                  color: "#546088",
                                }}
                              >
                                Tickets count of these{" "}
                                {calculateDays(
                                  selectedEDRange[0].startDate,
                                  selectedEDRange[0].endDate
                                )}{" "}
                                days
                              </div>
                            </div>

                            <div
                              className="d-flex"
                              style={{ marginLeft: "12px" }}
                            >
                              <img src={colon} alt="" />
                            </div>

                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "20px",
                                color: "#6929E2",
                              }}
                            >
                              {expectedDateCount}
                            </div>
                          </div>

                          <div>
                            {/* <select className="px-3 py-2" style={{ borderRadius: '8px', border: '0.5px #E5E5E5', color: '#6929E2', fontWeight: '700', fontSize: '12px' }}>
                                                    <option value="">Feb 23 - Mar 12 2024</option>
                                                </select> */}
                            {selectedEDRange[0].startDate != null && (
                              <div
                                onClick={() =>
                                  setShowEDRangePicker(!showEDRangePicker)
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  background: "#ffffff",
                                  border: "1px solid #6929E2",
                                  borderRadius: "8px",
                                  padding: "2px 6px",
                                }}
                              >
                                <div
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#6929E2",
                                  }}
                                >
                                  {" "}
                                  {commonFormatDate(
                                    selectedEDRange[0].startDate,
                                    "DD MMM"
                                  )}{" "}
                                  -{" "}
                                  {commonFormatDate(
                                    selectedEDRange[0].endDate,
                                    "DD MMM YYYY"
                                  )}{" "}
                                </div>
                                <CalendarClose
                                  onClick={() => {
                                    setExpectedDateRange([
                                      {
                                        startDate: new Date(), // Clear start date
                                        endDate: new Date(), // Clear end date
                                        key: "selection",
                                      },
                                    ]);
                                    setSelectedEDRange([
                                      {
                                        startDate: new Date(), // Clear start date
                                        endDate: new Date(), // Clear end date
                                        key: "selection",
                                      },
                                    ]);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#6929E2",
                                    marginLeft: "2px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {showEDRangePicker && (
                          <div
                            ref={alertEDPicRef}
                            style={{
                              position: "absolute",
                              top: "60px",
                              zIndex: 100,
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            <DateRangePicker
                              key={"expectedDateRange"}
                              ranges={expectedDateRange}
                              onChange={(item) => {
                                setExpectedDateRange([item.selection]);
                                setSelectedEDRange([item.selection]);
                              }}
                              showSelectionPreview={true}
                              moveRangeOnFirstSelection={false}
                              months={1} // Show two months
                              direction="horizontal"
                            />
                          </div>
                        )}
                      </div>
                      <div style={{ width: "100%", overflowX: "scroll" }}>
                        <div
                          style={{
                            minWidth: expectedDateList.length * 50,
                            height: "200px",
                          }}
                        >
                          {" "}
                          {/* Set minWidth for scrolling */}
                          <Bar
                            ref={chartExpeRef}
                            data={expectedDateBarChartData}
                            options={expectedDateBarChartOptions}
                            onClick={handleBarExpectClick}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row
                  style={{
                    borderRadius: "16px",
                    padding: "12px",
                    backgroundColor: "#FFFFFF",
                    margin: "12px 0px",
                  }}
                >
                  <Col sm={12} lg={6}>
                    <div>
                      <div style={{}}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "20px",
                            lineHeight: "22px",
                            color: "#212129",
                          }}
                        >
                          Advanced Overview
                        </span>
                      </div>

                      <div>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "12px",
                            lineHeight: "22px",
                            color: "#8790A1",
                          }}
                        >
                          You can set a date range, filter tickets for specific
                          times, and view their status simultaneously.
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col sm={12} lg={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ marginRight: "12px" }}>
                        <input
                          id="from_date"
                          type="date"
                          value={fromDate}
                          onChange={(event) => {
                            console.log(
                              "Region From Date....................................:",
                              event.target.value
                            );
                            setFromDate(event.target.value);
                          }}
                          style={{
                            width: "178px",
                            height: "44px",
                            borderRadius: "10px",
                            border: "0.8px solid #E5E5E5",
                            padding: "13px 16px 13px 16px",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      <div style={{ marginRight: "12px" }}>
                        <span>-</span>
                      </div>

                      <div style={{ marginRight: "12px" }}>
                        <input
                          id="to_date"
                          type="date"
                          value={toDate}
                          onChange={(event) => {
                            setToDate(event.target.value);
                          }}
                          style={{
                            width: "178px",
                            height: "44px",
                            borderRadius: "10px",
                            border: "0.8px solid #E5E5E5",
                            padding: "13px 16px 13px 16px",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      <div
                        onClick={() => {
                          console.log("From ", fromDate);
                          console.log("To ", toDate);
                          setFromDate("");
                          setToDate("");
                        }}
                        style={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "100px",
                          border: "0.8px solid #E5E5E5",
                          padding: "8px 12px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer", // 👈 add this for click feedback
                        }}
                      >
                        <img style={{ margin: 0 }} src={cancel} alt="cancel" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row style={{ margin: "0" }}>
                  <Col
                    sm={12}
                    md={2}
                    style={{ marginRight: "0", paddingRight: "0" }}
                  >
                    <div
                      style={{
                        height: "250px",
                        borderRadius: "16px 0px 0px 16px",
                        borderRight: "1px solid #E5E5E5",
                        padding: "16px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <div
                        style={{
                          height: "218px",
                          borderRadius: "24px",
                          padding: "12px",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <div
                          onClick={() => {
                            setAdvancedReportType("Team");
                            getTeamReport();
                          }}
                          style={{
                            height: "97px",
                            borderRadius: "12px",
                            padding: "16px",
                            backgroundColor:
                              advancedReportType === "Team"
                                ? "#FFFFFF"
                                : "#F7F7F7",
                          }}
                        >
                          <div
                            style={{
                              width: "75px",
                              height: "9px",
                              marginBottom: "20px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "22px",
                                color: "#212129",
                              }}
                            >
                              Team report
                            </span>
                          </div>
                          <div
                            style={{
                              width: "154px",
                              height: "15px",
                              marginBottom: "6px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "16px",
                                color: "#212129",
                              }}
                            >
                              {teamReport.team}
                            </span>
                          </div>
                          <div style={{ width: "154px", height: "9px" }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              Total Ticket Counts
                            </span>
                          </div>
                        </div>

                        <div
                          onClick={() => {
                            setAdvancedReportType("Your");
                            getYourReport();
                          }}
                          style={{
                            height: "97px",
                            borderRadius: "12px",
                            padding: "16px",
                            backgroundColor:
                              advancedReportType === "Your"
                                ? "#FFFFFF"
                                : "#F7F7F7",
                          }}
                        >
                          <div
                            style={{
                              width: "75px",
                              height: "9px",
                              marginBottom: "20px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "22px",
                                color: "#212129",
                              }}
                            >
                              Your report
                            </span>
                          </div>
                          <div
                            style={{
                              width: "154px",
                              height: "15px",
                              marginBottom: "6px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "16px",
                                color: "#212129",
                              }}
                            >
                              {teamReport.assigned}
                            </span>
                          </div>
                          <div style={{ width: "154px", height: "9px" }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              Total Ticket Counts
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    sm={12}
                    md={6}
                    style={{ marginLeft: "0", paddingLeft: "0" }}
                  >
                    <Row sm={12}>
                      <div
                        style={{
                          height: "250px",
                          borderRadius: "0 16px 16px 0",
                          backgroundColor: "#FFFFFF",
                          display: "flex",
                        }}
                      >
                        <Col sm={12} md={4} style={{ marginTop: "12px" }}>
                          <div style={{ width: "100px", height: "10px" }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "14px",
                                lineHeight: "18.9px",
                                color: "#212129",
                              }}
                            >
                              Team Report
                            </span>
                          </div>
                          <div
                            style={{
                              height: "240px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <ReactApexChart
                              options={teamChart.options}
                              series={teamChart.series}
                              type="radialBar"
                              height={230}
                              width={170}
                            />
                          </div>
                        </Col>

                        <Col sm={12} md={8} style={{ padding: "16px" }}>
                          <Row className="g-2">
                            <Col sm={12} md={4}>
                              <div
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_status: {
                                        label: "Open",
                                        value: "Open",
                                      },
                                      listing_type:
                                        advancedReportType === "Your"
                                          ? ticketOverview.type
                                          : teamType,
                                    },
                                  });
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "102px",
                                  borderRadius: "16px",
                                  border: "0.5px solid #E5E5E5",
                                  padding: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "2px",
                                      backgroundColor: "#6929E2",
                                      marginRight: "4.5px",
                                    }}
                                  ></div>
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Open
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#8790A1",
                                    marginBottom: "9px",
                                  }}
                                >
                                  Pct:{" "}
                                  <span style={{ color: "#A677FF" }}>
                                    {teamReport.open_percentage}%
                                  </span>
                                </div>
                                <div
                                  style={{ fontSize: "20px", fontWeight: 500 }}
                                >
                                  {teamReport.open}
                                </div>
                              </div>
                            </Col>

                            <Col sm={12} md={4}>
                              <div
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_status: {
                                        label: "In Progress",
                                        value: "In Progress",
                                      },
                                      listing_type:
                                        advancedReportType === "Your"
                                          ? ticketOverview.type
                                          : teamType,
                                    },
                                  });
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "102px",
                                  borderRadius: "16px",
                                  border: "0.5px solid #E5E5E5",
                                  padding: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "2px",
                                      backgroundColor: "#A677FF",
                                      marginRight: "4.5px",
                                    }}
                                  ></div>
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    InProgress
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#8790A1",
                                    marginBottom: "9px",
                                  }}
                                >
                                  Pct:{" "}
                                  <span style={{ color: "#A677FF" }}>
                                    {teamReport.inprogress_percentage}%
                                  </span>
                                </div>
                                <div
                                  style={{ fontSize: "20px", fontWeight: 500 }}
                                >
                                  {teamReport.inprogress}
                                </div>
                              </div>
                            </Col>

                            <Col sm={12} md={4}>
                              <div
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_status: {
                                        label: "Hold",
                                        value: "Hold",
                                      },
                                      listing_type:
                                        advancedReportType === "Your"
                                          ? ticketOverview.type
                                          : teamType,
                                    },
                                  });
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "102px",
                                  borderRadius: "16px",
                                  border: "0.5px solid #E5E5E5",
                                  padding: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "2px",
                                      backgroundColor: "#CCACE6",
                                      marginRight: "4.5px",
                                    }}
                                  ></div>
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Hold
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#8790A1",
                                    marginBottom: "9px",
                                  }}
                                >
                                  Pct:{" "}
                                  <span style={{ color: "#A677FF" }}>
                                    {teamReport.hold_percentage}%
                                  </span>
                                </div>
                                <div
                                  style={{ fontSize: "20px", fontWeight: 500 }}
                                >
                                  {teamReport.hold}
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Row className="g-2" style={{ marginTop: "9px" }}>
                            <Col sm={12} md={6}>
                              <div
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_status: {
                                        label: "Closed",
                                        value: "Closed",
                                      },
                                      listing_type:
                                        advancedReportType === "Your"
                                          ? ticketOverview.type
                                          : teamType,
                                    },
                                  });
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "102px",
                                  borderRadius: "16px",
                                  border: "0.5px solid #E5E5E5",
                                  padding: "16px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "2px",
                                      backgroundColor: "#CBAFFF",
                                      marginRight: "4.5px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Closed
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#8790A1",
                                    // marginBottom: "12px",
                                  }}
                                >
                                  Pct:{" "}
                                  <span style={{ color: "#A677FF" }}>
                                    {teamReport.closed_percentage}%
                                  </span>
                                </div>
                                <div
                                  style={{ fontSize: "20px", fontWeight: 500 }}
                                >
                                  {teamReport.closed ?? 0}
                                </div>
                              </div>
                            </Col>

                            <Col sm={12} md={6}>
                              <div
                                onClick={() => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_status: {
                                        label: "Completed",
                                        value: "Completed",
                                      },
                                      listing_type:
                                        advancedReportType === "Your"
                                          ? ticketOverview.type
                                          : teamType,
                                    },
                                  });
                                }}
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: "102px",
                                  borderRadius: "16px",
                                  border: "0.5px solid #E5E5E5",
                                  padding: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "2px",
                                      backgroundColor: "#E4D6FF",
                                      marginRight: "4.5px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Completed
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#8790A1",
                                    // marginBottom: "12px",
                                  }}
                                >
                                  Pct:{" "}
                                  <span style={{ color: "#A677FF" }}>
                                    {teamReport.completed_percentage ?? 0}%
                                  </span>
                                </div>
                                <div
                                  style={{ fontSize: "20px", fontWeight: 500 }}
                                >
                                  {teamReport.completed ?? 0}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </Row>
                  </Col>
                  <Col sm={12} md={4}>
                    <div
                      style={{
                        height: "250px",
                        borderRadius: "16px",
                        padding: "16px",
                        backgroundColor: "#FFFFFF",
                        marginLeft: "16px",
                      }}
                    >
                      <div style={{ width: "377px", height: "10px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18.8px",
                            color: "#212129",
                          }}
                        >
                          Monthly Project Report
                        </span>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          overflowX: "scroll",
                          marginTop: "14px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: monthlyProjectList.length * 70,
                            height: "190px",
                          }}
                        >
                          {" "}
                          {/* Set minWidth for scrolling */}
                          <Bar
                            ref={chartMonthProRef}
                            data={barChartData}
                            options={barChartOptions}
                            onClick={handleBarMonthlyClick}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {hasAnyPermission([
                  ["Team", "menu_permission"],
                  ["Project", "menu_permission"],
                  ["Client", "menu_permission"],
                  ["Component", "menu_permission"],
                ]) && (
                  <div
                    style={{
                      borderRadius: "16px",
                      padding: "16px",
                      gap: "16px",
                      backgroundColor: "#FFFFFF",
                      marginTop: "16px",
                    }}
                    // className="mb-3"
                  >
                    <div style={{ height: "10px", marginBottom: "16px" }}>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        {" "}
                        Master Overview
                      </span>
                    </div>

                    <Row>
                      {checkPermission("Team", "menu_permission") && (
                        <Col sm={6} lg={2}>
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={teams}
                                  style={{
                                    margin: "0",
                                    width: "15.44px",
                                    height: "14px",
                                    marginRight: "8px",
                                  }}
                                />
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    lineHeight: "18.9px",
                                    color: "#212129",
                                    margin: "0",
                                  }}
                                >
                                  Teams
                                </span>
                              </div>
                              {(checkPermission("Team", "menu_permission") ||
                                userType === "A" ||
                                userType === "SA") && (
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/team"
                                  className="teamMenu"
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100px",
                                      backgroundColor: "#FFFFFF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={carrow}
                                      style={{
                                        margin: "0",
                                        width: "8px",
                                        height: "8px",
                                      }}
                                    />
                                  </div>
                                </Link>
                              )}
                            </div>

                            <div style={{ width: "139px", height: "23px" }}>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "20px",
                                  lineHeight: "22.9px",
                                  color: "#21272C",
                                  margin: "0",
                                }}
                              >
                                {masterOverview.teams}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )}

                      {checkPermission("Project", "menu_permission") && (
                        <Col className="mt-3 mt-sm-0 mt-lg-0" sm={6} lg={2}>
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={projects}
                                  style={{
                                    margin: "0",
                                    width: "15.44px",
                                    height: "14px",
                                    marginRight: "8px",
                                  }}
                                />
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    lineHeight: "18.9px",
                                    color: "#212129",
                                    margin: "0",
                                  }}
                                >
                                  Projects
                                </span>
                              </div>
                              {(checkPermission("Project", "menu_permission") ||
                                userType === "A" ||
                                userType === "SA") && (
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/project"
                                  className="projectMenu"
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100px",
                                      backgroundColor: "#FFFFFF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={carrow}
                                      style={{
                                        margin: "0",
                                        width: "8px",
                                        height: "8px",
                                      }}
                                    />
                                  </div>
                                </Link>
                              )}
                            </div>

                            <div style={{ width: "139px", height: "23px" }}>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "20px",
                                  lineHeight: "22.9px",
                                  color: "#21272C",
                                  margin: "0",
                                }}
                              >
                                {masterOverview.projects}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )}

                      {checkPermission("Component", "menu_permission") && (
                        <Col className="mt-3 mt-sm-3 mt-lg-0" sm={6} lg={2}>
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={components}
                                  style={{
                                    margin: "0",
                                    width: "15.44px",
                                    height: "14px",
                                    marginRight: "8px",
                                  }}
                                />
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    lineHeight: "18.9px",
                                    color: "#212129",
                                    margin: "0",
                                  }}
                                >
                                  Component
                                </span>
                              </div>
                              {(checkPermission(
                                "Component",
                                "menu_permission"
                              ) ||
                                userType === "A" ||
                                userType === "SA") && (
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/component"
                                  className="componentMenu"
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100px",
                                      backgroundColor: "#FFFFFF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={carrow}
                                      style={{
                                        margin: "0",
                                        width: "8px",
                                        height: "8px",
                                      }}
                                    />
                                  </div>
                                </Link>
                              )}
                            </div>

                            <div style={{ width: "139px", height: "23px" }}>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "20px",
                                  lineHeight: "22.9px",
                                  color: "#21272C",
                                  margin: "0",
                                }}
                              >
                                {masterOverview.component}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )}

                      {/*  <Col className="mt-3 mt-sm-3 mt-lg-0" sm={6} lg={2} >
                                            <div style={{ borderRadius: '16px', padding: '16px', backgroundColor: '#F7F7F7', }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: "12px" }}>

                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <img src={modules} style={{ margin: '0', width: '15.44px', height: '14px', marginRight: '8px' }} />
                                                        <span style={{ fontFamily: 'Satoshi', fontWeight: '700', fontSize: '14px', lineHeight: '18.9px', color: '#212129', margin: '0' }}>Modules</span>
                                                    </div>

                                                    <div style={{ width: '32px', height: '32px', borderRadius: '100px', backgroundColor: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <img src={carrow} style={{ margin: '0', width: '8px', height: '8px' }} />
                                                    </div>

                                                </div>

                                                <div style={{ width: "139px", height: '23px' }}>
                                                    <span style={{ fontFamily: 'Satoshi', fontWeight: '500', fontSize: '20px', lineHeight: '22.9px', color: '#21272C', margin: '0' }}>{masterOverview.modules}</span>
                                                </div>
                                            </div>
                                        </Col> */}

                      {checkPermission("Client", "menu_permission") && (
                        <Col className="mt-3 mt-sm-3 mt-lg-0" sm={6} lg={2}>
                          <div
                            style={{
                              borderRadius: "16px",
                              padding: "16px",
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "12px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={clients}
                                  style={{
                                    margin: "0",
                                    width: "15.44px",
                                    height: "14px",
                                    marginRight: "8px",
                                  }}
                                />
                                <span
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    lineHeight: "18.9px",
                                    color: "#212129",
                                    margin: "0",
                                  }}
                                >
                                  Clients
                                </span>
                              </div>
                              {(checkPermission("Client", "menu_permission") ||
                                userType === "A" ||
                                userType === "SA") && (
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/client/list"
                                  className="projectMenu"
                                >
                                  <div
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "100px",
                                      backgroundColor: "#FFFFFF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={carrow}
                                      style={{
                                        margin: "0",
                                        width: "8px",
                                        height: "8px",
                                      }}
                                    />
                                  </div>
                                </Link>
                              )}
                            </div>

                            <div style={{ width: "139px", height: "23px" }}>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "20px",
                                  lineHeight: "22.9px",
                                  color: "#21272C",
                                  margin: "0",
                                }}
                              >
                                {masterOverview.clients}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                )}

                <Row>
                  {customerList.length > 0 && (
                    <Col sm={12} lg={6}>
                      <div
                        className="d-flex flex-column py-3 px-3 "
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderRadius: "16px",
                          flex: "6",
                          marginTop: "16px",
                          maxHeight: "350px",
                        }}
                      >
                        <div className="d-flex justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "16px",
                                color: "#212129",
                              }}
                            >
                              Customers based ticket count
                            </div>
                          </div>
                          <div className="text-end d-flex flex-column">
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "20px",
                                color: "#6929E2",
                              }}
                            >
                              {customerBillingTicketCount}
                            </div>

                            <div
                              style={{
                                fontWeight: "400",
                                fontSize: "12px",
                                color: "#546088",
                              }}
                            >
                              Billable tickets
                            </div>
                          </div>
                        </div>

                        <div
                          className="d-flex flex-column"
                          style={{
                            overflowY: "scroll",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                        >
                          {customerList.map((item, index) => (
                            <div
                              onClick={() => {
                                navigate("/ticket", {
                                  state: {
                                    // filter_customer: {
                                    //   value: 164,
                                    //   label: "Arun",
                                    // },
                                    filter_customer: {
                                      value: item.id ?? "",
                                      label: item.name,
                                    },

                                    listing_type: ticketOverview.type ?? "",
                                  },
                                });
                              }}
                              key={"progress-customer-" + index}
                              className="d-flex flex-column justify-content-between mb-4"
                              style={{ gap: "8px", cursor: "pointer" }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-between flex-10"
                                style={{ flex: 10 }}
                              >
                                <img
                                  src={
                                    item.image != null && item.image !== ""
                                      ? item.image
                                      : UserImg
                                  }
                                   onError={(e) => {
                                                                e.currentTarget.onerror = null;
                                                                e.currentTarget.src = UserImg;
                                                              }}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    marginRight: "8px",
                                    borderRadius: "100px",
                                  }}
                                />
                                <div
                                  style={{
                                    flex: 4,
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    lineHeight: "14.88px",
                                    color: "#212129",
                                  }}
                                >
                                  {item.name ?? ""}
                                </div>
                                <div style={{ flex: 5, marginRight: "8px" }}>
                                  <ProgressBar
                                    now={
                                      (item.count /
                                        customerBillingTicketCount) *
                                      100
                                    }
                                    className="custom-progress"
                                    style={{
                                      borderRadius: "2px",
                                      height: "6px",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "14.88px",
                                    color: "#1E1E1E",
                                    textAlign: "center",
                                  }}
                                >
                                  {item.count ?? ""} /{" "}
                                  {customerBillingTicketCount}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}

                  {vendorList.length > 0 && (
                    <Col sm={12} lg={6}>
                      <div
                        className="d-flex flex-column py-3 px-3"
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderRadius: "16px",
                          flex: "6",
                          marginTop: "16px",
                          maxHeight: "350px",
                        }}
                      >
                        <div className="d-flex justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "16px",
                                color: "#212129",
                              }}
                            >
                              Vendors based ticket count
                            </div>
                          </div>
                          <div className="text-end d-flex flex-column">
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "20px",
                                color: "#6929E2",
                              }}
                            >
                              {vendorBillingTicketCount}
                            </div>

                            <div
                              style={{
                                fontWeight: "400",
                                fontSize: "12px",
                                color: "#546088",
                              }}
                            >
                              Billable tickets
                            </div>
                          </div>
                        </div>

                        <div
                          className="d-flex flex-column"
                          style={{
                            overflowY: "scroll",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                        >
                          {vendorList.map((item, index) => (
                            <div
                              onClick={() => {
                                navigate("/ticket", {
                                  state: {
                                    filter_vendor: {
                                      value: item.id ?? "",
                                      label: item.name,
                                    },
                                    //                         filter_vendor:  {
                                    //     "value": 129,
                                    //     "label": "124"
                                    // },

                                    listing_type: vendorType,
                                  },
                                });
                              }}
                              key={"progress-vendor-" + index}
                              className="d-flex flex-column justify-content-between mb-4"
                              style={{ gap: "8px", cursor: "pointer" }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-between flex-10"
                                style={{ flex: 10 }}
                              >
                                <img
                                  src={
                                    item.image != null && item.image !== ""
                                      ? item.image
                                      : UserImg
                                  }
                                   onError={(e) => {
                                                                e.currentTarget.onerror = null;
                                                                e.currentTarget.src = UserImg;
                                                              }}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    marginRight: "8px",
                                    borderRadius: "100px",
                                  }}
                                />
                                <div
                                  style={{
                                    flex: 4,
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "14.88px",
                                    color: "#1E1E1E",
                                  }}
                                >
                                  {item.name ?? ""}
                                </div>
                                <div style={{ flex: 5, marginRight: "8px" }}>
                                  <ProgressBar
                                    variant="#6929E2"
                                    now={
                                      (item.count / vendorBillingTicketCount) *
                                      100
                                    }
                                    className="custom-progress"
                                    style={{
                                      borderRadius: "2px",
                                      height: "6px",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "14.88px",
                                    color: "#1E1E1E",
                                    textAlign: "center",
                                  }}
                                >
                                  {item.count ?? ""} /{" "}
                                  {vendorBillingTicketCount}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {/* </div>
                <Row> */}
                  {regionReport.length > 0 && (
                    <Col sm={12} lg={6}>
                      {
                        <div
                          className="custom-progress"
                          style={{ marginTop: "16px" }}
                        >
                          <div className="title">
                            Region report - {regionReport.length}
                          </div>

                          <div className="custom-scroll">
                            {regionReport.map((item, index) => (
                              <CustomChartCard
                                onCardClick={() => {
                                  console.log("item.id", item);
                                  console.log("item.id", item.id);
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_region: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                      listing_type: regionType,
                                    },
                                  });
                                }}
                                onStatusClick={(value) => {
                                  navigate("/ticket", {
                                    state: {
                                      filter_create: {
                                        start_date: fromDate,
                                        end_date: toDate,
                                      },
                                      filter_region: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                      filter_status: {
                                        label:
                                          value === "Progress"
                                            ? "In Progress"
                                            : value,
                                        value:
                                          value === "Progress"
                                            ? "In Progress"
                                            : value,
                                      },
                                      listing_type: ticketOverview.type ?? "",
                                    },
                                  });
                                }}
                                key={index}
                                title={item.title}
                                overall={item.overall}
                                legendData={item.legendData}
                                legendValue={item.legendValue}
                              />
                            ))}
                          </div>
                        </div>
                      }
                    </Col>
                  )}
                  {locationReport.length > 0 && (
                    <Col sm={12} lg={6}>
                      <div
                        className="custom-progress "
                        style={{ marginTop: "16px" }}
                      >
                        <div className="title">
                          Location report - {locationReport.length}
                        </div>

                        <div className="custom-scroll">
                          {locationReport.map((item, index) => (
                            <CustomChartCard
                              onCardClick={() => {
                                navigate("/ticket", {
                                  state: {
                                    filter_create: {
                                      start_date: fromDate,
                                      end_date: toDate,
                                    },
                                    filter_location: {
                                      label: item.title,
                                      value: item.id,
                                    },
                                    listing_type: ticketOverview.type ?? "",
                                  },
                                });
                              }}
                              onStatusClick={(value) => {
                                console.log("value", value);
                                navigate("/ticket", {
                                  state: {
                                    filter_create: {
                                      start_date: fromDate,
                                      end_date: toDate,
                                    },
                                    filter_location: {
                                      label: item.title,
                                      value: item.id,
                                    },
                                    filter_status: {
                                      label:
                                        value === "Progress"
                                          ? "In Progress"
                                          : value,
                                      value:
                                        value === "Progress"
                                          ? "In Progress"
                                          : value,
                                    },
                                    listing_type: locationType,
                                  },
                                });
                              }}
                              key={index}
                              title={item.title}
                              overall={item.overall}
                              legendData={item.legendData}
                              legendValue={item.legendValue}
                            />
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}

                  {teamNewReport.length > 0 && (
                    <Col sm={12} lg={6}>
                      <div
                        className="custom-progress"
                        style={{ marginTop: "16px" }}
                      >
                        <div className="title">
                          Team report - {teamNewReport.length}
                        </div>

                        <div className="custom-scroll">
                          <div
                            className="team-rep-container mt-2"
                            style={{ gap: 20 }}
                          >
                            {teamNewReport.map((item, index) => (
                              <div className="team-rep-card" key={index}>
                                <TechSupportCard
                                  onTiClick={(id) => {
                                    navigate("/ticket", {
                                      state: {
                                        filter_create: {
                                          start_date: fromDate,
                                          end_date: toDate,
                                        },
                                        filter_team: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                        listing_type: teamType,
                                      },
                                    });
                                  }}
                                  onCardClick={(value) => {
                                    navigate("/ticket", {
                                      state: {
                                        filter_create: {
                                          start_date: fromDate,
                                          end_date: toDate,
                                        },
                                        filter_team: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                        filter_status: {
                                          label:
                                            value === "Progress"
                                              ? "In Progress"
                                              : value,
                                          value:
                                            value === "Progress"
                                              ? "In Progress"
                                              : value,
                                        },
                                        listing_type: teamType,
                                      },
                                    });
                                  }}
                                  id={item.id}
                                  title={item.title}
                                  overall={item.overall}
                                  stats={{
                                    open: item.open,
                                    progress: item.progress,
                                    closed: item.closed,
                                    hold: item.hold,
                                    completed: item.completed,
                                  }}
                                />

                                <StackedBar
                                  segments={[
                                    {
                                      value: item.completed_per,
                                      color: "#E4D6FF",
                                    },

                                    {
                                      value: item.closed_per,
                                      color: "#CBAFFF",
                                    },
                                    {
                                      value: item.hold_per_per,
                                      color: "#CCACE6",
                                    },
                                    {
                                      value: item.progress_per,
                                      color: "#A677FF",
                                    },
                                    { value: item.open_per, color: "#6929E2" },
                                  ]}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {/* </Row>
                <Row> */}

                  {/* </Row>

                <Row> */}

                  {/* </Row>
                <Row> */}
                  {escalationTicket.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <div
                          style={{
                            width: "500px",
                            height: "10px",
                            gap: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            Escalation Tickets
                          </span>
                        </div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flex: "10",
                              borderBottom: "1px solid #EAEFF4",
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "419px",
                                height: "20px",
                                flex: "8",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Ticket Name
                              </span>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "20px",
                                flex: "2",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Status
                              </span>
                            </div>
                          </div>

                          {escalationTicket.map((item, index) => (
                            <Link
                              to={`/ticket/view/${item.id}`}
                              key={"recent-ticket-" + index}
                              state={{ id: item.id ?? 0 }}
                              className="link23"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flex: "10",
                                  borderBottom: "1px solid #EAEFF4",
                                  paddingBottom: "12px",
                                  paddingTop: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "20px",
                                    flex: "8",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      lineHeight: "19.6px",
                                      color: "#2A3547",
                                    }}
                                  >
                                    {item.name}{" "}
                                  </span>
                                </div>
                                <div style={{ height: "20px", flex: "2" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: getStatusColor(
                                          item.status
                                        ),
                                        borderRadius: "3px",
                                        margin: "0",
                                        marginRight: "8px",
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        color: "#2A3547",
                                        margin: "0",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {approvalTicket.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <div
                          style={{
                            width: "500px",
                            height: "10px",
                            gap: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            Approval Tickets
                          </span>
                        </div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flex: "10",
                              borderBottom: "1px solid #EAEFF4",
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "419px",
                                height: "20px",
                                flex: "8",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Ticket Name
                              </span>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "20px",
                                flex: "2",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Status
                              </span>
                            </div>
                          </div>

                          {approvalTicket.map((item, index) => (
                            <Link
                              to={`/ticket/view/${item.id}`}
                              key={"recent-assign-ticket-" + index}
                              state={{ id: item.id ?? 0 }}
                              className="link23"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flex: "10",
                                  borderBottom: "1px solid #EAEFF4",
                                  paddingBottom: "12px",
                                  paddingTop: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "20px",
                                    flex: "8",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      lineHeight: "19.6px",
                                      color: "#2A3547",
                                    }}
                                  >
                                    {item.name}{" "}
                                  </span>
                                </div>
                                <div style={{ height: "20px", flex: "2" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: getStatusColor(
                                          item.status
                                        ),
                                        borderRadius: "3px",
                                        margin: "0",
                                        marginRight: "8px",
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        color: "#2A3547",
                                        margin: "0",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {/* </Row>
                <Row> */}

                  {monProStatusReport.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",

                          width: "100%",
                        }}
                      >
                        {/* Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              color: "#212129",
                            }}
                          >
                            Monthly Project Status Report -{" "}
                            {dataStack?.labels?.length ?? 0}
                          </span>

                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <SearchBox />
                            <input
                              type="text"
                              placeholder="Search project..."
                              value={searchTerm}
                              onChange={handleChange}
                              style={{
                                padding: "6px 10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                              }}
                            />
                          </div>
                        </div>

                        {/* Scrollable chart */}
                        <div
                          style={{
                            maxWidth: "100%", // important
                            overflowX: "auto",
                            marginTop: "14px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div
                            style={{
                              // display: "inline-block",
                              minWidth: `${dataStack?.labels?.length * 80}px`, // give enough width
                              height: "214px",
                            }}
                          >
                            {dataStack?.labels?.length > 0 ? (
                              <Bar
                                options={options}
                                data={dataStack}
                                ref={chartProStatusRef}
                                onClick={handleBarProjectStatClick}
                              />
                            ) : (
                              <p>No data available</p>
                            )}
                          </div>
                        </div>

                        {/* <div
                          style={{
                            width: "100%",
                            overflowX: "auto",
                            marginTop: "14px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-block", // <-- forces horizontal expansion

                              minWidth: `${dataStack?.labels?.length * 30}px`, // adjust width per bar
                              height: "214px",
                            }}
                          >
                            {dataStack &&
                            dataStack.labels &&
                            dataStack.labels.length > 0 ? (
                              <Bar
                                options={options}
                                data={dataStack}
                                ref={chartProStatusRef}
                                onClick={handleBarProjectStatClick}
                              />
                            ) : (
                              <p>No data available</p>
                            )}
                          </div>
                        </div> */}
                      </div>
                    </Col>
                  )}
                  {recentlyUpdatedTicket.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <div
                          style={{
                            width: "500px",
                            height: "10px",
                            gap: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            Recently Updated Tickets
                          </span>
                        </div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flex: "10",
                              borderBottom: "1px solid #EAEFF4",
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "419px",
                                height: "20px",
                                flex: "8",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Ticket Name
                              </span>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "20px",
                                flex: "2",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Status
                              </span>
                            </div>
                          </div>

                          {recentlyUpdatedTicket.map((item, index) => (
                            <Link
                              to={`/ticket/view/${item.id}`}
                              key={"recent-ticket-" + index}
                              state={{ id: item.id ?? 0 }}
                              className="link23"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flex: "10",
                                  borderBottom: "1px solid #EAEFF4",
                                  paddingBottom: "12px",
                                  paddingTop: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "20px",
                                    flex: "8",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      lineHeight: "19.6px",
                                      color: "#2A3547",
                                    }}
                                  >
                                    {item.name}{" "}
                                  </span>
                                </div>
                                <div style={{ height: "20px", flex: "2" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: getStatusColor(
                                          item.status
                                        ),
                                        borderRadius: "3px",
                                        margin: "0",
                                        marginRight: "8px",
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        color: "#2A3547",
                                        margin: "0",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {recentlyAssignedTicket.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <div
                          style={{
                            width: "500px",
                            height: "10px",
                            gap: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            Recently Assigned Tickets
                          </span>
                        </div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flex: "10",
                              borderBottom: "1px solid #EAEFF4",
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "419px",
                                height: "20px",
                                flex: "8",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Ticket Name
                              </span>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "20px",
                                flex: "2",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Status
                              </span>
                            </div>
                          </div>

                          {recentlyAssignedTicket.map((item, index) => (
                            <Link
                              to={`/ticket/view/${item.id}`}
                              key={"recent-assign-ticket-" + index}
                              state={{ id: item.id ?? 0 }}
                              className="link23"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flex: "10",
                                  borderBottom: "1px solid #EAEFF4",
                                  paddingBottom: "12px",
                                  paddingTop: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "20px",
                                    flex: "8",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      lineHeight: "19.6px",
                                      color: "#2A3547",
                                    }}
                                  >
                                    {item.name}{" "}
                                  </span>
                                </div>
                                <div style={{ height: "20px", flex: "2" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: getStatusColor(
                                          item.status
                                        ),
                                        borderRadius: "3px",
                                        margin: "0",
                                        marginRight: "8px",
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        color: "#2A3547",
                                        margin: "0",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {unallocatedTicket.length > 0 && (
                    <Col sm={12} lg={6} style={{ marginTop: "16px" }}>
                      <div
                        style={{
                          borderRadius: "16px",
                          padding: "16px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <div
                          style={{
                            width: "500px",
                            height: "10px",
                            gap: "4px",
                            marginBottom: "14px",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            Unallocated Tickets
                          </span>
                        </div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flex: "10",
                              borderBottom: "1px solid #EAEFF4",
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "419px",
                                height: "20px",
                                flex: "8",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Ticket Name
                              </span>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "20px",
                                flex: "2",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "19.6px",
                                  color: "#7C8FAC",
                                }}
                              >
                                Status
                              </span>
                            </div>
                          </div>

                          {unallocatedTicket.map((item, index) => (
                            <Link
                              to={`/ticket/view/${item.id}`}
                              key={"recent-ticket-" + index}
                              state={{ id: item.id ?? 0 }}
                              className="link23"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flex: "10",
                                  borderBottom: "1px solid #EAEFF4",
                                  paddingBottom: "12px",
                                  paddingTop: "12px",
                                }}
                              >
                                <div
                                  style={{
                                    height: "20px",
                                    flex: "8",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      lineHeight: "19.6px",
                                      color: "#2A3547",
                                    }}
                                  >
                                    {item.name}{" "}
                                  </span>
                                </div>
                                <div style={{ height: "20px", flex: "2" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: getStatusColor(
                                          item.status
                                        ),
                                        borderRadius: "3px",
                                        margin: "0",
                                        marginRight: "8px",
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        lineHeight: "19.6px",
                                        color: "#2A3547",
                                        margin: "0",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {Number(ticketOverview.allocated) > 0 && (
                    <Col sm={12} lg={3} className="mt-3">
                      <div
                        className="w-100"
                        style={{
                          height: "87.33px",
                          borderRadius: "16px",
                          padding: "12px 16px 12px 0px",
                          backgroundColor: "#FFFFFF",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        // onClick={() => {
                        //   navigate("/ticket", {
                        //     state: {
                        //       filter_status: {
                        //         label: "Open",
                        //         value: "Open",
                        //       },
                        //       listing_type: ticketOverview.type ?? "",
                        //     },
                        //   });
                        // }}
                      >
                        <div
                          style={{
                            width: "4px",
                            height: "40px",
                            borderRadius: "27px 17px 27px 17px",
                            backgroundColor: "Transparent",
                          }}
                        ></div>

                        <div style={{ height: "54px", width: "54px" }}>
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Allocated
                          </p>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "18px",
                              lineHeight: "24.3px",
                              color: "#212129",
                            }}
                          >
                            {ticketOverview.allocated ?? "0"}
                          </span>
                        </div>

                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "28px",
                          }}
                        ></div>
                      </div>
                    </Col>
                  )}
                  {Number(ticketOverview.self_assigned) > 0 && (
                    <Col sm={12} lg={3} className="mt-3">
                      <div
                        className="w-100"
                        style={{
                          height: "87.33px",
                          borderRadius: "16px",
                          padding: "12px 16px 12px 0px",
                          backgroundColor: "#FFFFFF",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        //
                      >
                        <div
                          style={{
                            width: "4px",
                            height: "40px",
                            borderRadius: "27px 17px 27px 17px",
                            backgroundColor: "Transparent",
                          }}
                        ></div>

                        <div style={{ height: "54px", width: "84px" }}>
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Self assigned
                          </p>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "18px",
                              lineHeight: "24.3px",
                              color: "#212129",
                            }}
                          >
                            {ticketOverview.self_assigned ?? ""}
                          </span>
                        </div>

                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "28px",
                          }}
                        ></div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default DashboardView;
